export default __webpack_public_path__ + "static/zois-3d907ef11d95fff14233661bdf607d27.svg";